import React, { useState } from 'react';
import {
  Dimensions,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { LocStr } from '../utils/Utils';
import MyMessagePopup from './MyMessagePopup';
import {
  cancel_str,
  confirm_str,
  Duplicate_a_service,
  getSubCategoryId,
  Give_it_name,
  name_already_exists,
  ok_str,
  please_enter_service_name,
} from '../utils/DictionaryManagementUtils';

//= ========================================================================
const MyAddServicePopup = ({
  parentWidth = 560,
  onYesPressed,
  onNoPressed,
  globJSON,
  language,
  service,
}) => {
  const [state, setState] = useState({
    service_name: service.name,
  });

  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });

  const screenHeight = Dimensions.get('window').height;

  const noBtnWidth = 126;
  const yesBtnWidth = 126;
  const counterOffsetY = 54;

  //----------------------------------------------------------------

  const handleConfirmPressed = () => {
    // check if name is empty
    if (state.service_name.length === 0) {
      const txt = LocStr(please_enter_service_name, language);
      setMessagePopupState({ isMessageVisible: true, title: txt });
      return;
    }

    onYesPressed(service, state.service_name);
  };

  //----------------------------------------------------------------

  return (
    <View
      style={{
        width: 464,
        height: 242,
        marginTop: '80%',
        justifyContent: 'center',
        position: 'absolute',
      }}
    >
      <View
        style={{
          width: 464,
          height: 316,
          alignSelf: 'center',
          backgroundColor: '#d9d9d9',
          borderRadius: 8,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.22,
          shadowRadius: 12,
        }}
      >
        <View
          style={{
            width: 464 - 2,
            padding: 32,
            flexDirection: 'column',
            margin: 1,
            backgroundColor: '#fff',
            borderRadius: 6,
          }}
        >
          <Text
            style={{
              width: 349,
              height: 30,
              fontFamily: 'Quicksand-SemiBold',
              fontSize: 24,
              textAlign: 'left',
              color: '#001a2f',
              fontWeight: 'bold',
            }}
          >
            {LocStr(Duplicate_a_service, language)}
          </Text>

          {/* ----------------------------------------------------------------------------------------------- */}

          <Text
            style={{
              marginTop: 12,
              fontFamily: 'Quicksand-SemiBold',
              fontSize: 20,
              fontWeight: 600,
              textAlign: 'left',
              color: '#008CFF',
            }}
          >
            {service.name}
          </Text>

          <Text
            style={{
              marginTop: 24,
              fontFamily: 'Quicksand-SemiBold',
              fontSize: 16,
              textAlign: 'left',
              color: '#001a2f',
            }}
          >
            {LocStr(Give_it_name, language)}
          </Text>

          <View
            style={{
              marginTop: 12,
              borderRadius: 4,
              borderWidth: 1,
              borderColor: '#cbd5e0',
            }}
          >
            <TextInput
              style={{
                margin: 1,
                height: 48,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 2,
                backgroundColor: '#fff',
                fontFamily: 'Rubik-Regular',
                fontSize: 16,
                textAlign: 'left',
                color: '#001a2f',
                borderBottomWidth: 4,
                borderTopWidth: 4,
                borderRightWidth: 4,
                borderLeftWidth: 4,
                borderColor: '#fff',
              }}
              value={state.service_name}
              multiline={false}
              selectTextOnFocus
              maxLength={100}
              placeholder={state.service_name}
              placeholderTextColor="#a0aec0"
              onChangeText={(newText) => {
                setState({ ...state, service_name: newText });
              }}
              onKeyPress={(e) => {
                if (e.nativeEvent.key === 'Enter') {
                }
              }}
            />
          </View>

          {/* ----------------------------------------------------------------------------------------------- */}

          <View
            style={{
              marginTop: 30,
              width: 400,
              height: 50,
              flexDirection: 'row',
              justifyContent: 'right',
            }}
          >
            <TouchableOpacity
              style={{
                width: noBtnWidth,
                height: 50,
                backgroundColor: '#cbd5e0',
                borderRadius: 5,
              }}
              onPress={() => {
                onNoPressed();
              }}
            >
              <View
                style={{
                  width: noBtnWidth - 2,
                  height: 48,
                  margin: 1,
                  backgroundColor: '#fff',
                  borderRadius: 4,
                }}
              >
                <Text
                  style={[
                    styles.lblButton,
                    {
                      marginTop: 14,
                      width: noBtnWidth - 4,
                    },
                  ]}
                >
                  {LocStr(cancel_str, language)}
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                marginLeft: 24,
                width: yesBtnWidth,
                height: 50,
                backgroundColor: '#008cff',
                borderRadius: 5,
              }}
              onPress={() => {
                handleConfirmPressed();
              }}
            >
              <View
                style={{
                  width: yesBtnWidth - 2,
                  height: 48,
                  // position: 'absolute',
                  margin: 1,
                  backgroundColor: '#008cff',
                  borderRadius: 4,
                }}
              >
                <Text
                  style={[
                    styles.lblButton,
                    {
                      marginTop: 14,
                      width: yesBtnWidth - 4,
                      color: '#fff',
                    },
                  ]}
                >
                  {LocStr(confirm_str, language)}
                </Text>
              </View>
            </TouchableOpacity>
          </View>

          {/* ----------------------------------------------------------------------------------------------- */}
        </View>
      </View>

      {messagePopupState.isMessageVisible ? (
        <MyMessagePopup
          parentWidth={parentWidth}
          onOkPressed={() => setMessagePopupState({ isMessageVisible: false, title: '' })}
          okTitle={LocStr(ok_str, language)}
          message={messagePopupState.title}
          language={language}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  lblButton: {
    fontFamily: 'Rubik-Medium',
    fontSize: 18,
    textAlign: 'center',
    color: '#008cff',
    position: 'absolute',
  },
});

export default MyAddServicePopup;
